import React from 'react';
import { Modal } from 'react-bootstrap';
import { actions } from 'react-redux-form';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Text } from '../../InputField2';
import { Formik } from 'formik';
import Actions from '../../../modules/common/actions';
import * as Yup from 'yup';
import { push } from 'connected-react-router';

const Comp = ({ show }) => {
  const dispatch = useDispatch();
  const formRef = React.useRef();
  const close = () => {
    dispatch(actions.change('forms.setting.loadUserDataShowModal', false));
  };
  const handleSubmit = () => {
    formRef.current.handleSubmit();
  };
  const loadUserData = (values) => {
    dispatch(
      Actions.customer.getUserData.request({
        id: values.loadId,
      })
    );
    dispatch(actions.change('forms.setting.loadUserDataShowModal', false));
  };
  const schema = Yup.object().shape({
    loadId: Yup.string().required(),
  });

  return (
    <Modal size="sm" show={show} onHide={close} className="change-plan">
      <Modal.Header closeButton>
        <Modal.Title>
          ユーザデータの呼び出し（IDを指定してください）
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={{ loadId: '' }}
          validationSchema={schema}
          enableReinitialize
          onSubmit={loadUserData}
          innerRef={formRef}
        >
          {(props) => {
            return (
              <Text
                label="ID"
                name="loadId"
                type="text"
                placeholder="IDを入力"
                required
              />
            );
          }}
        </Formik>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="submit"
          className="btn btn-primary"
          onClick={handleSubmit}
        >
          呼び出す
        </button>
        <button className="btn btn-secondary" onClick={close}>
          閉じる
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default connect((s) => s)(Comp);
